/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectTimeUpdateCommand } from '../../models/delete-project-time-update-command';
import { DeleteProjectTimeUpdateCommandResult } from '../../models/delete-project-time-update-command-result';

export interface ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Params {
      body?: DeleteProjectTimeUpdateCommand
}

export function apiProjectTimeUpdateDeleteProjectTimeUpdateDelete(http: HttpClient, rootUrl: string, params?: ApiProjectTimeUpdateDeleteProjectTimeUpdateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTimeUpdateDeleteProjectTimeUpdateDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectTimeUpdateCommandResult>;
    })
  );
}

apiProjectTimeUpdateDeleteProjectTimeUpdateDelete.PATH = '/api/ProjectTimeUpdate/DeleteProjectTimeUpdate';
